import { Avatar, Badge } from "../../../ui/index.ts";
import { capitalizeWords } from "../../../../utils/format-display-text.ts";
import { useEmployeePhotoSource } from "../hooks/use-employee-photo-source.ts";
import type { EmployeeDirectoryCardData } from "../types.ts";
import styles from "./employee-view-directory.module.css";

function joinedDate(value: string): string {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

function formatEmployeeType(employeeType: string): string {
  const normalized = employeeType.replace(/[_\s-]+/g, "").toUpperCase();
  if (normalized === "SQELABS") return "SQELabs";
  return capitalizeWords(employeeType.replace(/[_-]+/g, " "));
}

export function EmployeeViewDirectoryCard({ employee, onClick }: { employee: EmployeeDirectoryCardData; onClick: () => void }) {
  const photoSource = useEmployeePhotoSource(employee.photoPath);

  return <button type="button" className={styles.employeeCard} onClick={onClick}>
    <div className={styles.cardTop}>
      <Avatar
        name={employee.employeeName}
        src={photoSource}
        size="md"
        className={styles.directoryAvatar}
      />
      <div className={styles.cardIdentity}>
        <span title={employee.employeeName} className="heading-xs">{employee.employeeName}</span>
        <span title={employee.designation} className="sub-heading-sm">{employee.designation}</span>
        {/* <span className={styles.employeeCode}>{employee.employeeCode}</span> */}
        <span className={styles.department}>{employee.department}</span>
      </div>
     
    </div>
    <div className={styles.cardFooter}>
      <Badge variant="success">
        {formatEmployeeType(employee.employeeType)}
      </Badge>
      <span className="sub-heading-sm">Joined {joinedDate(employee.dateOfJoining)}</span>
    </div>
  </button>;
}
